/**
 * RPS-LEVEL
 * Niveau RPS global d'une fonction : pastille, et libelle au besoin.
 */
import { getRpsLevel, RPS_EMPTY_COLOR } from "../model/rps-risk"
import RiskDot from "@/components/RiskDot"

interface Props {
  level: number | null //null : non evalue
  isLabelVisible?: boolean
}

export default function RpsLevel({ level, isLabelVisible }: Props) {
  const item = getRpsLevel(level)

  return (
    <span className="inline-flex items-center gap-[6px]">
      <RiskDot color={item?.color ?? RPS_EMPTY_COLOR} />
      {isLabelVisible && item && <span>{item.label}</span>}
    </span>
  )
}
